
import axios from 'axios'

export default {
    getApplications: function () {
        return axios
            .get("[baseContextPath]/applications")
            .then(response => {
                return response.data;
            })
    },
    getApplicationsWithUnreleasedChanges: function () {
        return axios
            .get("[baseContextPath]/applications/containingUnreleasedChanges")
            .then(response => {
                return response.data;
            })
    },
    getAvailableUpdateChanges: function (applicationName, fromVersion, toVersion) {
        return axios.get(`[baseContextPath]/applications/${encodeURIComponent(applicationName)}/available-update-changes`, {
            params: { fromVersion, toVersion }
        }).then(response => response.data)
    },
    ignoreUnreleasedChanges: function (applicationName) {
        return axios.post(`[baseContextPath]/applications/${encodeURIComponent(applicationName)}/ignore-unreleased-changes`)
    },
    unignoreUnreleasedChanges: function (applicationName) {
        return axios.delete(`[baseContextPath]/applications/${encodeURIComponent(applicationName)}/ignore-unreleased-changes`)
    },
    ignoreAvailableUpdate: function (applicationName) {
        return axios.post(`[baseContextPath]/applications/${encodeURIComponent(applicationName)}/ignore-available-update`)
    },
    unignoreAvailableUpdate: function (applicationName) {
        return axios.delete(`[baseContextPath]/applications/${encodeURIComponent(applicationName)}/ignore-available-update`)
    },
    saveApplicationConfiguration: function (configuration) {
        return axios
            .post("[baseContextPath]/applications", configuration)
            .then(response => {
                return response.data;
            })
    }
}
